import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { Schema, SchemaService } from '../../services/schema/schema.service';

@Component({
  selector: 'fin-schema',
  templateUrl: 'schema.component.html',
  host: { ngSkipHydration: 'true' },
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SchemaComponent {
  private sanitizer = inject(DomSanitizer);
  private schemaService = inject(SchemaService);

  readonly htmls = computed<SafeHtml[]>(() => {
    return this.schemaService.schemas().map((schema) => {
      return this.getSafeHTML(schema);
    });
  });

  private getSafeHTML(schema: Schema): SafeHtml {
    const json = schema ? JSON.stringify(schema, null, 2).replace(/<\/script>/g, '<\\/script>') : ''; // escape / to prevent script tag in JSON
    const html = `<script type="application/ld+json">${json}</script>`;
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
